import './styles/index.css';
import { initTheme } from './theme';
import { App } from './ui/views/App';

initTheme();

const root = document.getElementById('app');
if (root) new App(root);
